import moment from 'moment';
import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import Loading from '../components/shared/Loading';
import { getPostById } from '../services/blogApi';
import CalendarIcon from '../assets/imgs/calendar.png';

const DetailsBlog = () => {
  const { id } = useParams();

  const { isLoading, data } = useQuery(['posts', { Id: id }], getPostById, {
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });


  return (
    <div style={{ minHeight: 'calc(100vh - 225px)' }} className="pt-20 px-4 pb-24">
      <div className="max-w-4xl mx-auto">
        {isLoading ? (
          <Loading />
        ) : (
          data && (
            <>
              <h3 className="text-4xl font-bold mb-4 text-blue-800 text-center">{data.Title}</h3>
              <img
                src={data.ImageUrl}
                alt={data.Title}
                className="h-64 object-cover object-center w-full rounded-lg mb-6"
              />
              <div className="md:flex items-center justify-between mb-5">
                <p className="italic font-light flex items-center text-gray-600">
                  <img src={CalendarIcon} alt="calendar" className="mr-2 w-5 h-5" />
                  {moment(data.CreatedAt).format('MMMM DD, YYYY')}
                </p>
              </div>
              <div
                className="text-lg text-gray-800 leading-relaxed text-left"
                dangerouslySetInnerHTML={{ __html: data.Description }}
              />
            </>
          )
        )}
      </div>
    </div>
  );
};

export default DetailsBlog;
